import * as React from "react";
import type { SVGProps } from "react";
const SvgTwitter = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M9.03 21.02a15.8 15.8 0 0 1-7.51-2 1 1 0 0 1 .52-1.87 7.6 7.6 0 0 0 3.91-.95 8.1 8.1 0 0 1-3.62-4.32 9.8 9.8 0 0 1 .8-7.23 1 1 0 0 1 1.302-.404 1 1 0 0 1 .378.314A8.43 8.43 0 0 0 11 8.12a4.9 4.9 0 0 1 3.27-4.65 4.86 4.86 0 0 1 5 .56l.19-.05a11.5 11.5 0 0 0 2.09-.72 1 1 0 0 1 1.07.12 1 1 0 0 1 .34 1 18 18 0 0 1-1.38 3.13c-.15.28-.33.63-.41.8a14.8 14.8 0 0 1-.53 3.86 12 12 0 0 1-8.34 8.43 11.6 11.6 0 0 1-3.27.42m-3.47-2.5a11 11 0 0 0 6.2.14 10 10 0 0 0 7-7.05c.313-1.133.468-2.304.46-3.48 0-.34.13-.6.63-1.56l.39-.76h-.2l-.72.2a1 1 0 0 1-1-.29 2.85 2.85 0 0 0-3.28-.46 2.92 2.92 0 0 0-2 2.78v1a1 1 0 0 1-1 1A10.43 10.43 0 0 1 4.3 7.02a7 7 0 0 0-.07 4.21 7 7 0 0 0 4.17 4 1 1 0 0 1 .16 1.75 15 15 0 0 1-3 1.54"
    />
  </svg>
);
export default SvgTwitter;
